import { OrderBaseUrls } from '@ravago/shared/page-data/models/elements';

export async function getOrderBaseUrls(language: string): Promise<OrderBaseUrls> {
  const response = await fetch(`/api/orders/routes?language=${language}`);
  if (!response.ok) {
    return {
      orderOverviewBaseUrl: '',
      orderDetailBaseUrl: '',
      shipmentBaseUrl: '',
      callOffAgreementBaseUrl: '',
      productBaseUrl: '',
      myProductsAndPricesBaseUrl: ''
    };
  }
  return response.json();
}

export async function getSystemPageUrl(language: string, type: string): Promise<string> {
  const response = await fetch(`/api/system-pages/${type}/?language=${language}`);
  if (!response.ok) {
    return '';
  }

  return response.json();
}
